import Home from "../pages/Home";

const publicRoutes = [
  { path: "/:tramite?", component: Home }
]

export { publicRoutes };
